import { ImageCard } from './ImageCard'
import type { ImageRead } from '@/types/image'

interface ImagesGridProps {
  images: ImageRead[]
  loading: boolean
  onUpdate: (
    imageId: string,
    data: { name?: string; description?: string }
  ) => void
  onDelete: (imageId: string) => void
  updatingId?: string
}

export function ImagesGrid({
  images,
  loading,
  onUpdate,
  onDelete,
  updatingId,
}: ImagesGridProps) {
  if (loading) {
    return (
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
        {Array.from({ length: 10 }).map((_, i) => (
          <div
            key={i}
            className="rounded-lg border border-border bg-card overflow-hidden animate-pulse"
          >
            <div className="aspect-square bg-muted" />
            <div className="p-3 space-y-2">
              <div className="h-4 bg-muted rounded w-3/4" />
              <div className="h-3 bg-muted rounded w-1/2" />
            </div>
          </div>
        ))}
      </div>
    )
  }

  if (images.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-16 text-center">
        <p className="text-sm text-muted-foreground">No images found</p>
        <p className="text-xs text-muted-foreground mt-1">
          Upload images to get started
        </p>
      </div>
    )
  }

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
      {images.map(image => (
        <ImageCard
          key={image.id}
          image={image}
          onUpdate={onUpdate}
          onDelete={onDelete}
          isUpdating={updatingId === image.id}
        />
      ))}
    </div>
  )
}
